import { useQuery } from "@tanstack/vue-query";
import { computed, type Ref, unref } from "vue";
import OrganizationSetting from "@/services/organization/organization-setting";

export interface OrganizationSettingParams {
  organizationId: string;
}

export function useOrganizationSetting(
  params: Ref<OrganizationSettingParams | null> | OrganizationSettingParams | null
) {
  const queryKey = computed(() => {
    const p = unref(params);
    if (!p) return ["organizationSetting", "disabled"];
    return ["organizationSetting", p.organizationId];
  });

  const enabled = computed(() => {
    const p = unref(params);
    return p !== null && p !== undefined;
  });

  return useQuery({
    queryKey,
    queryFn: async () => {
      const p = unref(params);
      if (!p) throw new Error("Parameters not ready");

      const result = await OrganizationSetting.getOrganizationSettings(p);

      if (result.data.status && result.data.data && result.data.data.length > 0) {
        return result.data.data[0];
      }

      throw new Error(result.data.msg || "Failed to load organization settings");
    },
    enabled,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}
